<script>
import Service from '../../services/movement-instruction';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

export default{
  components: {DataTable, Column},
  props: ['id'],
  data(){
    return {
      data: []
    }
  },
  mounted(){
    this.loadLog();
  },
  computed: {
      constants(){
          return CommonConstants;
      },
      utils(){
        return Utils;
      }
  },
  methods: {
    loadLog(){
      if(this.id != 0){

        let params = {
          movementInstructionHeaderId : this.id
        }

        params.sort = JSON.stringify([{property: 'OperationDate', direction: 'desc'}])

        Service.getLog(params, response => {
          if(response.success){
            this.data = response.data;
          }
        });
      }
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
      <div class="col-12">
        <DataTable :value="data" showGridlines stripedRows :reorderableColumns="true">
            <Column field="operationLogMessage" :header="$t('message')" dataType="string" :sortable="true">
                <template #body="element">
                  {{element.data.operationLogMessage}}
                </template>
            </Column>
            <Column field="operationDate" :header="$t('operationDate')" dataType="string" :sortable="true">
                <template #body="element">
                  {{element.data.operationDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.operationDate)) : null}}
                </template>
            </Column>
            <template #empty>
              {{$t('noRecordsFound')}}
            </template>
        </DataTable>
      </div>
    </div>
  </main>
</template>
